import { ContractorsPlannedHoursWizardCalculationResultsList } from "@/modules/contractorsPlannedHoursWizard/components/lists/ContractorsPlannedHoursWizardCalculationResultsList";
import { ContractorsPlannedHoursWizardSelectedForCalculateList } from "@/modules/contractorsPlannedHoursWizard/components/lists/ContractorsPlannedHoursWizardSelectedForCalculateList";
import {
  DisplayContractorsPlannedHoursWizardAllocation,
  ReadContractorsPlannedHoursWizardResult,
} from "@/types/contractorsPlannedHoursWizard";
import { useTranslation } from "react-i18next";

function ResultsSectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="mb-1 flex items-center px-1">
      <span className="text-sm font-medium text-gray-500">{children}</span>
    </div>
  );
}

export function ContractorsPlannedHoursWizardResultsPanel({
  results,
  snapshotAllocations,
}: {
  results: ReadContractorsPlannedHoursWizardResult[];
  snapshotAllocations: DisplayContractorsPlannedHoursWizardAllocation[];
}) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2">
      <div className="flex min-w-0 flex-col">
        <ResultsSectionLabel>
          {t("contractorsPlannedHoursWizard.results.calculatedHoursTableLabel")}
        </ResultsSectionLabel>
        <ContractorsPlannedHoursWizardCalculationResultsList
          results={results}
        />
      </div>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <ResultsSectionLabel>
          {t(
            "contractorsPlannedHoursWizard.results.selectedAllocationsTableLabel",
          )}
        </ResultsSectionLabel>
        <ContractorsPlannedHoursWizardSelectedForCalculateList
          snapshotAllocations={snapshotAllocations}
        />
      </div>
    </div>
  );
}
